import { createReducer } from 'utils/reduxCreators';
import {
  fetchPersonalInfo,
  fetchActivePaymentMethod,
  fetchBalanceToSettle,
  fetchCallNotes,
  fetchTransactions,
  fetchNextPayment,
  fetchMembershipDue,
  fetchDefaultFeeDue,
  fetchPendingPaymentAmount,
} from 'services/accountDetails';
import { fetchAllTransactions } from 'services/transactions';

export const RECEIVED_PERSONAL_INFO = 'cd/RECEIVED_PERSONAL_INFO';
export const RECEIVED_BALANCE = 'cd/RECEIVED_BALANCE';
export const RECEIVED_ACTIVE_PAY_METHOD = 'cd/RECEIVED_ACTIVE_PAY_METHOD';
export const RECEIVED_NEXT_PAY_AMOUNT = 'cd/RECEIVED_NEXT_PAY_AMOUNT';
export const RECEIVED_TRANSACTIONS = 'cd/RECEIVED_TRANSACTIONS';
export const RECEIVED_ALL_TRANSACTIONS = 'cd/RECEIVED_ALL_TRANSACTIONS';
export const RECEIVED_CALL_NOTES = 'cd/RECEIVED_CALL_NOTES';
export const RECEIVED_MEMBERSHIP_DUE_STATUS =
  'cd/RECEIVED_MEMBERSHIP_DUE_STATUS';
export const RECEIVED_PENDING_PAYMENT_AMOUNT =
  'cd/RECEIVED_PENDING_PAYMENT_AMOUNT';
export const RECEIVED_DEFAULT_FEE_DUE = 'cd/RECEIVED_DEFAULT_FEE_DUE';

const initialState = {};

export default createReducer(initialState, {
  [RECEIVED_PERSONAL_INFO]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  },
  [RECEIVED_BALANCE]: (state, { payload }) => {
    return {
      ...state,
      balanceToSettle: payload,
    };
  },
  [RECEIVED_ACTIVE_PAY_METHOD]: (state, { payload }) => {
    return {
      ...state,
      payMethod: payload,
    };
  },
  [RECEIVED_NEXT_PAY_AMOUNT]: (state, { payload }) => {
    return {
      ...state,
      nextPaymentAmount: payload,
    };
  },
  [RECEIVED_TRANSACTIONS]: (state, { payload }) => {
    return {
      ...state,
      lastest3Transactions: payload,
    };
  },
  [RECEIVED_ALL_TRANSACTIONS]: (state, { payload }) => {
    return {
      ...state,
      transactions: payload,
    };
  },
  [RECEIVED_CALL_NOTES]: (state, { payload }) => {
    return {
      ...state,
      callNotes: payload,
    };
  },
  [RECEIVED_MEMBERSHIP_DUE_STATUS]: (state, { payload }) => {
    return {
      ...state,
      membershipDue: payload,
    };
  },
  [RECEIVED_PENDING_PAYMENT_AMOUNT]: (state, { payload }) => {
    return {
      ...state,
      pendingPaymentAmount: payload,
    };
  },
  [RECEIVED_DEFAULT_FEE_DUE]: (state, { payload }) => {
    return {
      ...state,
      defaultFeeDue: payload,
    };
  },
});

export const getPersonalInfo = (adfitNo) => async (dispatch) => {
  const result = await fetchPersonalInfo(adfitNo);
  dispatch({ type: RECEIVED_PERSONAL_INFO, payload: result });
};

export const getBalanceToSettle = (adfitNo) => async (dispatch) => {
  const result = await fetchBalanceToSettle(adfitNo);
  dispatch({ type: RECEIVED_BALANCE, payload: result });
};

export const getActivePayMethod = (adfitNo) => async (dispatch) => {
  const result = await fetchActivePaymentMethod(adfitNo);
  dispatch({ type: RECEIVED_ACTIVE_PAY_METHOD, payload: result });
};

export const getNextPaymentAmount = (adfitNo) => async (dispatch) => {
  const result = await fetchNextPayment(adfitNo);
  dispatch({ type: RECEIVED_NEXT_PAY_AMOUNT, payload: result });
};

export const getTransactions = (adfitNo) => async (dispatch) => {
  const result = await fetchTransactions(adfitNo);
  dispatch({ type: RECEIVED_TRANSACTIONS, payload: result });
};

export const getAllTransactions = (adfitNo) => async (dispatch) => {
  const result = await fetchAllTransactions(adfitNo);
  dispatch({ type: RECEIVED_ALL_TRANSACTIONS, payload: result });
};

export const getCallNotes = (adfitNo) => async (dispatch) => {
  const result = await fetchCallNotes(adfitNo);
  dispatch({ type: RECEIVED_CALL_NOTES, payload: result });
};

export const getMembershipDue = (adfitNo) => async (dispatch) => {
  const result = await fetchMembershipDue(adfitNo);
  dispatch({ type: RECEIVED_MEMBERSHIP_DUE_STATUS, payload: result });
};

export const getPendingPaymentAmount = (adfitNo) => async (dispatch) => {
  const result = await fetchPendingPaymentAmount(adfitNo);
  dispatch({
    type: RECEIVED_PENDING_PAYMENT_AMOUNT,
    payload: result.pendingPaymentAmount,
  });
};
export const getDefaultFeeDue = (adfitNo) => async (dispatch) => {
  const result = await fetchDefaultFeeDue(adfitNo);
  dispatch({ type: RECEIVED_DEFAULT_FEE_DUE, payload: result });
};
